export enum Roles {
  tenantManager,
  superAdmin,
  admin,
  staff,
  student,
  setaVisitor,
  geust,
  tester
}
